import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './PromotionsDetail.css';
import API_BASE_URL from "../../config/api";

import Carna from "../ProductDetail/Carna/Carna";
import FalconS from "../ProductDetail/FalconS/FalconS";
import Familie from "../ProductDetail/Familie/Familie";
import Phantom from "../ProductDetail/Phantom/Phantom";
import Quantum from "../ProductDetail/Quantum/Quantum";
import Eden from "../ProductDetail/Eden/Eden";

const PROMO_PRODUCTS = [
  // ===== Phantom Rovo（Healthcare Robot） =====
  {
    sku: "BF-001",
    name: "Phantom Rovo",
    slug: "phantom-rovo",
    category: "Healthcare Robot",
    isNew: true,
    product_type: "Healthcare Robot",
    installmentPrice: "RM374.98*/month",
    npPrice: "RM32,999",
    features: [
      "XD-Pro Massage Module",
      "Finger Moving technology",
      "Precise control of massage balls",
      "Stimulates lower body and core muscles",
      "Stretching and relaxation in a massage chair"
    ],
    images: [
      "Website Sale Oct Promo-05.jpg",
      "Phantom_Rovo_1.jpg",
      "Phantom_Rovo_2.jpg",
      "Phantom_Rovo_3.jpg",
      "Phantom_Rovo_4.jpg",
      "Phantom_Rovo_5.jpg",
      "Phantom_Rovo_6.jpg",
      "Phantom_Rovo_7.jpg"
      
    ],
    detailsImages: [
      "uploads/displayImages/Phantom_Rovo/Phantom_01.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_02.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_03.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_04.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_05.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_06.jpg",
      "uploads/displayImages/Phantom_Rovo/Phantom_07.jpg"
    ]
  },
  // ===== Eden（Massage Bed） =====
  {
    sku: "BF-002",
    name: "Eden",
    slug: "eden",
    category: "Massage Bed",
    isNew: false,
    product_type: "Massage Bed",
    installmentPrice: "RM374.98*/month",
    npPrice: "RM32,999",
    features: [
      "Sofa-style design",
      "Air pressure massage",
      "Heating function",
      "6 auto programs",
      "Bluetooth speaker"
    ],
    images: [
      "Website Sale Oct Promo-03.jpg",
      "eden_thumb_1000_side.jpg",
      "eden_thumb_1000_half.jpg",
      "eden_thumb_1000_1.jpg",
      "eden_thumb_1000_2.jpg",
      "eden_thumb_1000_3.jpg"
    ],
    detailsImages: [
      "uploads/displayImages/Eden/eden_intro.mp4",
      "uploads/displayImages/Eden/Eden_01.png",
      "uploads/displayImages/Eden/Eden_02.png",
      "uploads/displayImages/Eden/Eden_03.png"
      
    ]
  },
  // ===== Falcon S（Healthcare Robot） =====
  {
    sku: "BF-003",
    name: "Falcon S",
    slug: "falcon-s",
    category: "Healthcare Robot",
    isNew: false,
    product_type: "Healthcare Robot",
    installmentPrice: "RM249.98*/month",
    npPrice: "RM19,999",
    features: [
      "Zero gravity positioning",
      "Heat therapy",
      "Full body airbags",
      "Foot roller massage",
      "12 auto programs"
    ],
    images: [
      "Website Sale Oct Promo-04.jpg",
      "falcon_s_thumb_1000_1.jpg",
      "falcon_s_thumb_1000_2.jpg",
      "falcon_s_thumb_1000_3.jpg",
      "falcon_s_thumb_1000_4.jpg"
      
    ],
    detailsImages: [
      "uploads/displayImages/Falcon_S/FalconS_01.png",
      "uploads/displayImages/Falcon_S/FalconS_02.png",
      "uploads/displayImages/Falcon_S/FalconS_03.png",
      "uploads/displayImages/Falcon_S/FalconS_04.png",
      "uploads/displayImages/Falcon_S/FalconS_05.png",
      "uploads/displayImages/Falcon_S/FalconS_06.png",
      "uploads/displayImages/Falcon_S/FalconS_07.jpg"
    ]
  },
  // ===== Famille（Massage Sofa） =====
  {
    sku: "BF-004",
    name: "Famille",
    slug: "famille",
    category: "Massage Sofa",
    isNew: false,
    product_type: "Massage Sofa",
    installmentPrice: "RM111.09*/month",
    npPrice: "RM10,999",
    features: [
      "Elegant sofa design",
      "Full body massage",
      "Heat therapy",
      "Air pressure technology",
      "Bluetooth connectivity"
    ],
    images: [
      "Website Sale Oct Promo-01.jpg",
      "familie_thumb_620_side.jpg",
      "familie_thumb_620_half.jpg",
      "familie_thumb_620_half_02.jpg",
      "familie_thumb_620_1.jpg",
      "familie_thumb_620_2.jpg",
      "familie_thumb_620_3.jpg",
      "familie_thumb_620_4.jpg",
      "familie_thumb_620_5.jpg",
      "familie_thumb_620_6.jpg"
    ],
    detailsImages: [
      "uploads/displayImages/Familie/Familie_01.png",
      "uploads/displayImages/Familie/Familie_02.png",
      "uploads/displayImages/Familie/Familie_03.png",
      "uploads/displayImages/Familie/Familie_04.png",
      "uploads/displayImages/Familie/Familie_05.png",
      "uploads/displayImages/Familie/Familie_06.png",
      "uploads/displayImages/Familie/Familie_07.jpg"
    ]
  },
  // ===== Carna（Massage Chair） =====
  {
    sku: "BF-005",
    name: "Carna",
    slug: "carna",
    category: "Massage Chair",
    isNew: false,
    product_type: "Massage Chair",
    installmentPrice: "RM277.75*/month",
    npPrice: "RM18,999",
    features: [
      "Advanced massage technology",
      "Full body coverage",
      "Heat therapy",
      "Zero gravity positioning",
      "Multiple auto programs"
    ],
    images: [
      "Website Sale Oct Promo-02.jpg",
      "carna_thumb_1000_1.jpg",
      "carna_thumb_1000_2.jpg",
      "carna_thumb_1000_3.jpg",
      "carna_thumb_1000_4.jpg",
      "carna_thumb_1000_5.jpg"

    ],
    detailsImages: [
      "uploads/displayImages/Carna/Carna_01.png",
      "uploads/displayImages/Carna/Carna_02.png",
      "uploads/displayImages/Carna/Carna_03.png",
      "uploads/displayImages/Carna/Carna_04.png",
      "uploads/displayImages/Carna/Carna_05.png",
      "uploads/displayImages/Carna/Carna_06.png",
      "uploads/displayImages/Carna/Carna_07.png",
      "uploads/displayImages/Carna/Carna_08.png",
      "uploads/displayImages/Carna/Carna_09.png",
      "uploads/displayImages/Carna/Carna_10.png",
      "uploads/displayImages/Carna/Carna_11.png",
      "uploads/displayImages/Carna/Carna_12.png",
      "uploads/displayImages/Carna/Carna_13.png",
      "uploads/displayImages/Carna/Carna_14.jpg"
    ]
  },
  // ===== Quantum（Healthcare Robot） =====
  {
    sku: "BF-006",
    name: "Quantum Audio Speakers by Bang & Olufsen",
    slug: "quantum",
    category: "Healthcare Robot",
    isNew: true,
    product_type: "Healthcare Robot",
    installmentPrice: "RM499.98*/month",
    npPrice: "RM47,999",
    features: [
      "Advanced AI technology",
      "Full body massage",
      "Heat therapy",
      "Zero gravity positioning",
      "Bluetooth speakers"
    ],
    images: [
      "Website Sale Oct Promo-06.jpg",
      "quantum_thumb_1000_1.jpg",
      "quantum_thumb_1000_2.jpg",
      "quantum_thumb_1000_3.jpg",
      "quantum_thumb_1000_4.jpg",
      "quantum_thumb_1000_5.jpg"

    ],
    detailsImages: [
      "uploads/displayImages/QuantumB&O/Quantum_01.png",
      "uploads/displayImages/QuantumB&O/Quantum_02.png",
      "uploads/displayImages/QuantumB&O/Quantum_03.png",
      "uploads/displayImages/QuantumB&O/Quantum_04.png",
      "uploads/displayImages/QuantumB&O/Quantum_05.png",
      "uploads/displayImages/QuantumB&O/Quantum_06.png",
      "uploads/displayImages/QuantumB&O/Quantum_07.png",
      "uploads/displayImages/QuantumB&O/Quantum_08.png",
      "uploads/displayImages/QuantumB&O/Quantum_09.png"
    ]
  }
];

const PromotionsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const product = PROMO_PRODUCTS.find(p => p.slug === slug);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: (i) => <div className="dot-line"></div>,
  };

  const handleWhatsApp = () => {
    const phoneNumber = '60123723759';
    const message = `Hello, I am interested in: ${product?.name} (Promotion). Can you provide more details?`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleBack = () => {
    navigate('/promotions');
  };

  const toggleViewMore = () => {
    setIsExpanded((prev) => !prev);
  };

  const imageBaseURL = `${API_BASE_URL}/uploads/productImages/`;

  if (!product) {
    return (
      <div className="promo-detail-wrap">
        <div className="promo-detail-notfound">
          <h2>Product Not Found</h2>
          <p>The promotional product you are looking for does not exist.</p>
          <p style={{ fontSize: 14, color: '#888' }}>Available slugs: phantom-rovo, eden, falcon-s, famille, carna, quantum</p>
          <button onClick={handleBack} className="back-to-promo-btn">← Back to Promotions</button>
        </div>
      </div>
    );
  }

  return (
    <div className="promo-detail-wrap">
      <div className="product_details_container">
        <div className="product_image_container">
          {product.images && product.images.length > 0 ? (
            <Slider {...sliderSettings}>
              {product.images.map((imgUrl, index) => (
                <div key={index}>
                  <img
                    src={`${imageBaseURL}${imgUrl}`}
                    alt={`${product.name} - ${index + 1}`}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/600x400?text=No+Image';
                    }}
                  />
                </div>
              ))}
            </Slider>
          ) : (
            <p>No images available</p>
          )}
        </div>

        <div className="product_info">
          <div className="general_info_top">
            <div className="info_header_row">
              <div className="info_header_left">
                <span className="product_type">{product.product_type || product.category}</span>
                <h1 className="product_name">
                  {product.name}
                  {product.isNew && <span className="badge_new">NEW</span>}
                </h1>
              </div>

              <div className="promo_price_section">
                <span className="price_main">{product.installmentPrice}</span>
                <span className="price_np">{product.npPrice}</span>
                <span className="price_tnc">*Terms &amp; Conditions Apply</span>
              </div>
            </div>
          </div>

          <div className="info_divider"></div>

          {product.features && product.features.length > 0 && (
            <div className="general_info_section">
              <h2 className="features_title">Key Features</h2>
              <ul className="features_list">
                {product.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="promo-actions">
            <button className="whatsapp-btn" onClick={handleWhatsApp}>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Us
            </button>
            <button className="back-btn" onClick={handleBack}>← Back to Promotions</button>
          </div>
        </div>
      </div>

{/* =========================================================
    PRODUCT BROCHURE / DETAIL IMAGES
    ========================================================= */}

{product.slug === "carna" ? (
  <div className="carna-brochure-container">
    <Carna />
  </div>

) : product.slug === "falcon-s" ? (
  <div className="falcons-brochure-container">
    <FalconS />
  </div>

) : product.slug === "famille" ? (
  <div className="familie-brochure-container">
    <Familie />
  </div>

) : product.slug === "phantom-rovo" ? (
  <div className="phantom-brochure-container">
    <Phantom />
  </div>

) : product.slug === "quantum" ? (
  <div className="quantum-brochure-container">
    <Quantum />
  </div>

) : product.slug === "eden" ? (
  <div className="eden-brochure-container">
    <Eden />
  </div>

) : (
  product.detailsImages &&
  product.detailsImages.length > 0 && (
    <div
      className={`display_img_container ${
        isExpanded ? "expanded" : ""
      }`}
    >
      {product.detailsImages.map((imgUrl, index) => {
        const isVideo = imgUrl.endsWith(".mp4");

        return isVideo ? (
          <video
            key={index}
            src={`${API_BASE_URL}/${imgUrl}`}
            autoPlay
            loop
            playsInline
            muted
            className="product_display_img"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            key={index}
            src={`${API_BASE_URL}/${imgUrl}`}
            alt={`Detail ${index + 1}`}
            className="product_display_img"
            onError={(e) => {
              console.error("Failed to load image:", imgUrl);
              e.target.src =
                "https://via.placeholder.com/800x600?text=No+Image";
            }}
          />
        );
      })}

      <div className="view_more_section">
        <button onClick={toggleViewMore}>
          {isExpanded ? "View Less" : "View More"}
        </button>
      </div>
    </div>
  )
)}

    </div>
  );
};

export default PromotionsDetail;